import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { userInfoStore } from '../../store/userInfoStore';
import { httpClient } from '../http';
import { gameService } from '../gameService';
import { gameDrawer } from '../gameDrawer';
import { gameStore } from '../../store/gameStore';
import { gambleStore } from '../../store/gambleStore';
import { jackPotStore } from '../../store/jackPotStore';
import { winPopupStore } from '../../store/winPopupStore';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';
import { winBarStore } from '../../store/winBarStore';
import { userSettingsStore } from '../../store/userSettingsStore';
import { soundService } from '../soundService';
import { applicationStore } from '../../store/applicationStore';
import { gameGlobalStates } from '../../core/constants/symbolsNames';

class BetReplayService {
  async getBetReplayData() {
    const { httpUrl: url } = environmentBuilder();
    const { betReplayTokenBySpin } = userInfoStore;
    const response = await httpClient.get(`${url}/api/Bet?token=${betReplayTokenBySpin}`);

    this.resetUIState();

    const { data } = response;
    const result = this.mapReplayData(data);
    gameStore.setReplayData(result);

    gameService.onGetInitialStateResult({
      validation: 10,
      matrix: data.replayInitialState.matrix,
      hasGamble: data.replayInitialState.hasGamble,
      autobet: data.replayInitialState.autoBet,
      currencyCode: data.replayInitialState.currencyCode,
      quickBets: data.replayInitialState.quickBets,
      defaultBetAmount: data.replayInitialState.amount,
      boostedJackpotInfo: data.replayInitialState.boostedJackpotInfo,
    });

    setTimeout(
      () => {
        gameStore.setGameGlobalState(gameGlobalStates.none);
        gameDrawer.startSpinAnimation();
        gameService.handleSpinResult({
          result,
          validation: 10,
          balance: 0,
          odd: result.odd,
          winAmount: result.winAmount,
          gambleInfo: result.gambleResult,
        });
      },
      gameStore.isReplayWatchAgain ? 0 : 3000
    );
  }

  resetUIState() {
    userSettingsStore.setIsSoundOn(false);
    soundService.stopAll();
    gambleStore.setGambleHistoryCards([]);
    winPopupStore.winPopupClose();
    boostedJackpotStore.setIsWheel(false);
    winBarStore.setWinAmount(0);
    winBarStore.setLastWinAmount(0);
    winBarStore.hideAmountContainer();
    boostedJackpotStore.setIsBoostedJackpotWinPopup(false);
    applicationStore.setIsShowMobileBigWinLayer(false);
    applicationStore.setIsShowBlackLayer(false);
  }

  mapReplayData(data) {
    const gambleResult = data?.spin?.gambleResult || null;

    return {
      validation: 10,
      balance: 0,
      totalWinAmount: data.spin.totalWinAmount,
      winAmount: data.spin.winAmount,
      bonus: data.bonus,
      odd: data.spin.odd,
      matrix: data.spin.result?.matrix?.length
        ? data.spin.result.matrix
        : data.spin.result?.[0]?.matrix,
      gambleResult,
      additional: {
        wins: data.spin.result?.additional?.wins,
        expandingWild: data.spin.result?.additional?.expandingWild,
      },
    };
  }

  sendReplayMessage() {
    window.parent.postMessage({ name: 'replayFinish', value: true }, '*');
    gameStore.setIsReplayWatchAgain(false);
  }

  sendReplayEventEnd = () => {
    applicationStore.setIsShowMobileBigWinLayer(false);
    const { gambleResult } = gameStore.replayData;
    const gambleAttemptsCount = gambleResult?.gambleAttemptsCount;

    if (gambleResult?.gambledCount) {
      this.showGambleCards(gambleResult, gambleAttemptsCount);
    } else {
      gambleStore.setIsShowGamblePopup(false);
      const { additional } = gameStore.replayData;
      const delay = additional?.wins?.length ? additional.wins.length * 1000 : 0;
      setTimeout(() => this.sendReplayMessage(), delay);
    }
  };

  showGambleCards(gambleResult, gambleAttemptsCount) {
    const { openedCards, playerSelectedCards, gambleAmountsInfo, totalWinAmount } = gambleResult;

    gambleStore.setIsShowGamblePopup(true);
    winPopupStore.winPopupClose();

    openedCards.forEach((card, index) => {
      setTimeout(() => {
        gameService.handleGambleResult({
          isWin: gambleAmountsInfo?.[index + 1],
          validation: 10,
          gambleCard: card,
          gambleAmountsInfo: gambleAmountsInfo[index + 1],
          totalWinAmount,
          gambleAttemptsCount: --gambleAttemptsCount,
          gambleFinished: index + 1 === playerSelectedCards.length,
        });
        gambleStore.setIsGambleLose(card !== playerSelectedCards[index]);

        if (index === openedCards.length - 1) {
          setTimeout(() => {
            this.sendReplayMessage();
            applicationStore.setIsShowBlackLayer(false);
            gambleStore.setIsShowGamblePopup(false);
          }, 2500);
        }
      }, 800 + index * 2000);
    });
  }

  startReplayJackpotScene() {
    const {
      bonus: {
        jackpotSceneInfo: { cardsInfo },
        jackpotAmounts,
      },
    } = gameStore.replayData;

    const isWinIndex = cardsInfo.findIndex((el) => el.isWin);
    const openedIcons = cardsInfo.slice(0, isWinIndex + 1);
    const notOpenedIcons = cardsInfo.slice(isWinIndex + 1);

    jackPotStore.setJackpotAmounts(jackpotAmounts);

    openedIcons.forEach((el, index) => {
      setTimeout(() => {
        if (el.isOpened) {
          gameService.handleJackpotSceneItemResult({
            validation: 10,
            jackpotSceneItemInfo: {
              ...el,
              winAmount: el.isWin ? gameStore.replayData.winAmount : 0,
            },
            jackpotSceneItemInfos: notOpenedIcons,
          });
        }
      }, 500 + index * 2000);
    });
  }

  startReplayBoostedJackpotScene() {
    const {
      bonus: {
        jackpotSceneInfo: { index, winAmount },
      },
    } = gameStore.replayData;

    if (index !== undefined) {
      gameService.handleBoostedJackpotWinResult({
        index,
        winAmount,
        validationType: 10,
      });
    }
  }
}

export const betReplayService = new BetReplayService();
